// ProductsSwiper class
class ProductsSwiper {
  constructor(el) {
    this.el = el.startsWith('.') ? el.slice(1) : el; // Remove the leading dot to use as a class name
    if ($("." + this.el).length > 0) {
      this.initSwipers();
    }
  }

  initSwipers() {
    const swiperEle = "." + this.el;

    // Initialize the thumbnail Swiper
    const mySwiper_thumb = new Swiper(swiperEle + ' .swiper-sub', {
      slidesPerView: 'auto',
      spaceBetween: 10,
      freeMode: true,
      watchSlidesProgress: true,
    });

    // Initialize the main Swiper
    const mySwiper_main = new Swiper(swiperEle + ' .swiper-main', {
      slidesPerView: 1,
      spaceBetween: 10,
      speed: 500,
      loop: true,
      autoplay: {
        delay: 2000,
      },
      thumbs: {
        swiper: mySwiper_thumb, // Link the thumbnail Swiper
      },
    });
  }
}

// Instantiate the ProductsSwiper class
new ProductsSwiper('.products-swiper');
